module.exports = __webpack_public_path__ + "static/media/lexus-pin.633ece0c.svg";